import { I18n } from 'i18n-js'
import moment from 'moment'

I18n.defaultLocale = 'lv'
I18n.locale = 'lv'

moment.locale(I18n.locale)
window.I18n = new I18n

export default I18n
